export const getLocalIsoDate = (date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const addMonthsToIsoDate = (isoDate: string, months: number): string => {
  const [year, month, day] = isoDate.split('-').map(Number);
  const date = new Date(year, month - 1 + months, day);

  return getLocalIsoDate(date);
};

export const formatScheduleDisplayDate = (isoDate?: string | null): string => {
  if (!isoDate) {
    return '';
  }

  const [year, month, day] = isoDate.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/**
 * Schedule runs are hour-granular only (EventBridge tick = every hour).
 * Minutes and seconds are always forced to `00`.
 */
export const normalizeTimeOfDay = (timeValue: string): string => {
  const raw = timeValue.trim();
  const hoursPart = raw.split(':')[0] ?? '0';
  const parsed = Number.parseInt(hoursPart, 10);
  const hour = Number.isFinite(parsed)
    ? Math.min(23, Math.max(0, parsed))
    : 0;

  return `${String(hour).padStart(2, '0')}:00:00`;
};

/** True when `timeOfDay` is on the hour (`HH:00` or `HH:00:00`). */
export const isHourAlignedTimeOfDay = (timeValue?: string | null): boolean => {
  if (!timeValue?.trim()) {
    return false;
  }

  return /^([01]\d|2[0-3]):00(?::00)?$/.test(timeValue.trim());
};
